import { useState } from 'react';
import { Topbar, Sidebar } from "../../../components";
import DateFilter from './DateFilter';
import { useDispatch, useSelector } from 'react-redux';
import { selectAccessToken } from '../../../slices/staffSlice';
import { show } from '../../../slices/toastSlice';
import { fetchRequests } from '../../../Requests/getRequests';
import { dateToHumanFormatShort, cediSign } from '../../../utils/constants';
import { HugeiconsIcon } from '@hugeicons/react';
import { Money01Icon } from '@hugeicons/core-free-icons';

function Index() {

    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const today = new Date().toISOString().split('T')[0];
    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);
    const [processing, setProcessing] = useState(false);
    const [payments, setPayments] = useState([]);
    const [hasSearched, setHasSearched] = useState(false);

    const filterPayments = async(e) => {
        if (e?.preventDefault) e.preventDefault();
        setProcessing(true);

        const res = await fetchRequests(
            `/payments/staff/filter-payments`, "GET",
            { 'Content-Type': 'application/json', 'authorization': `${accessToken}` },
            { startDate, endDate }, {}
        );
        setProcessing(false);
        setHasSearched(true);

        if(res?.code === 401) {
            sessionStorage.clear();
            dispatch(show({ type: "error", state: true, message: "Your session has expired. Please login to continue." }));
            return;
        }
        if(res?.err) {
            dispatch(show({ type: "error", state: true, message: res?.err }));
            return;
        }

        dispatch(show({ type: "success", state: true, message: "Payments updated successfully" }));
        setPayments(res);
    };

    return (
        <div className="main-container">
            <Topbar />
            <Sidebar />

            <main className="main-content">
                <section className="section-container space-y-6">

                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <div className="w-9 h-9 rounded-xl bg-amber-50 border border-amber-100 flex items-center justify-center shrink-0">
                                <HugeiconsIcon icon={Money01Icon} size={18} className="text-amber-600" />
                            </div>
                            <div>
                                <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-50">Recent Payments</h1>
                                <p className="text-sm text-gray-400">Filter payments by date range</p>
                            </div>
                        </div>

                        <DateFilter
                            startDate={startDate}
                            setStartDate={setStartDate}
                            endDate={endDate}
                            setEndDate={setEndDate}
                            filterPayments={filterPayments}
                            processing={processing}
                        />
                    </div>

                    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm overflow-hidden">
                        <table className="min-w-full">
                            <thead>
                                <tr className="bg-gray-50/60 dark:bg-gray-900/60 border-b border-gray-100 dark:border-gray-700">
                                    <th className="px-5 py-3.5 text-left text-xs font-semibold text-gray-500 uppercase tracking-wide w-[22%]">Transaction ID</th>
                                    <th className="px-5 py-3.5 text-left text-xs font-semibold text-gray-500 uppercase tracking-wide w-[36%]">Payee</th>
                                    <th className="px-5 py-3.5 text-left text-xs font-semibold text-gray-500 uppercase tracking-wide">Amount</th>
                                    <th className="px-5 py-3.5 text-left text-xs font-semibold text-gray-500 uppercase tracking-wide">Date Paid</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-50 dark:divide-gray-700/50">
                                {payments.length > 0 ? (
                                    payments.map((payment, index) => (
                                        <tr key={index} className="hover:bg-gray-50/40 dark:hover:bg-gray-700/30 transition-colors">
                                            <td className="px-5 py-3.5 text-sm text-gray-500 dark:text-gray-400 font-mono">
                                                {payment?.transactionId}
                                            </td>
                                            <td className="px-5 py-3.5">
                                                <p className="text-sm font-medium text-gray-800 dark:text-gray-200">
                                                    {payment?.updatedBy === "staff" ? "Staff" : "Client"}
                                                </p>
                                                <p className="text-xs text-gray-400 dark:text-gray-500 mt-0.5 font-mono">{payment?.loanId}</p>
                                            </td>
                                            <td className="px-5 py-3.5 text-sm font-semibold text-gray-800 dark:text-gray-200 tabular-nums">
                                                {cediSign} {payment?.amount}
                                            </td>
                                            <td className="px-5 py-3.5 text-sm text-gray-500 dark:text-gray-400">
                                                {dateToHumanFormatShort(payment?.createdAtms)}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="px-5 py-12 text-center">
                                            <p className="text-sm text-gray-400">
                                                {hasSearched ? 'No payments found for the selected range' : 'Select a date range and click Filter to view payments'}
                                            </p>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {payments.length > 0 && (
                            <div className="px-5 py-3 border-t border-gray-50 dark:border-gray-700 bg-gray-50/40 dark:bg-gray-900/40">
                                <p className="text-xs text-gray-400 dark:text-gray-500">{payments.length} payment{payments.length !== 1 ? 's' : ''} found</p>
                            </div>
                        )}
                    </div>

                </section>
            </main>
        </div>
    );
}

export default Index;
